export default __webpack_public_path__ + "static/media/expl-gradcam_07_EN.ffe3a83d.png";